import {DataSource} from "@angular/cdk/collections";
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { map } from 'rxjs/operators';
import { Observable, of as observableOf, merge } from 'rxjs';
import { TaskModel } from "../../../domain/models/task.model";

export class TaskListDatasource extends DataSource<TaskModel> {
  paginator: MatPaginator | undefined;
  sort: MatSort | undefined;
  filter: Filter | undefined;

  constructor(public data :TaskModel[] ) {
    super();
  }

  /**
   *  TODO: Connect to the service
   */
  connect(): Observable<TaskModel[]> {
    if (this.paginator && this.sort && this.data) {
      // Combine everything that affects the rendered data into one update
      // stream for the data-table to consume.
      return merge(observableOf(this.data), this.paginator.page, this.sort.sortChange)
        .pipe(map(() => {
          return this.getPagedData(this.getSortedData([...this.data ]));
        }));
    } else {
      throw Error('Please set the paginator and sort on the data source before connecting.');
    }
  }

  /**
   *  TODO: Use this to close any connection once we connect directly to the service
   */
  disconnect(): void {}

  private getPagedData(data: TaskModel[]): TaskModel[] {
    if (this.paginator) {
      const startIndex = this.paginator.pageIndex * this.paginator.pageSize;
      return data.splice(startIndex, this.paginator.pageSize);
    } else {
      return data;
    }
  }

  private getSortedData(data: TaskModel[]): TaskModel[] {
    if (!this.sort || !this.sort.active || this.sort.direction === '') {
      return data;
    }

    return data.sort((a, b) => {
      const isAsc = this.sort?.direction === 'asc';
      switch (this.sort?.active) {
        case 'dateReceived': return compare(a.dateReceived?.valueOf(), b.dateReceived?.valueOf(), isAsc);
        case 'type': return compare(+a.type, +b.type, isAsc);
        case 'status': return compare(+a.status, +b.status, isAsc);
        default: return 0;
      }
    });
  }

  private getFilteredData(data: TaskModel[]): TaskModel[] {
    if (!this.filter?.value) {
      return data; // No filter applied, return the original data
    }

    switch (this.filter?.property) {
      case 'type': return data.filter((item) => item.type === this.filter?.value);
      case 'status': return data.filter((item) => item.status === this.filter?.value);
      default: return data;
    }
    // Example: Filter by 'status' property

  }

}

/** Simple sort comparator for example ID/Name columns (for client-side sorting). */
function compare(a: string | number, b: string | number, isAsc: boolean): number {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

export interface Filter {
  property: string,
  value: string
}
